import apiClient from '@/api/index'
import router from '@/router';

export const feedbackNPSModule = {
    namespaced: true,

    state:() => ({
        filterset: null,
        filtersetLoading: true,
        filterSpecs: {
            date_range: [],
            shop: []
        },
        feedbackLoading: true,
        feedbackData: null
    }),

    mutations: {
        setFeedbackData(state, data) {
            state.feedbackData = data
            state.feedbackLoading = false
        },

        setFilterset(state, data) {
            state.filterSpecs['date_range'] = []
            state.filterSpecs['compare_date_range'] = []
            state.filterSpecs['shop'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else {
                                if(data[filter].choices[i].checked) {
                                    state.filterSpecs[filter].push(data[filter].choices[i].value)
                                }
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query

                queries.date_from ? state.filterSpecs['date_range'].push(queries.date_from) : state.filterSpecs['date_range'].push('')
                queries.date_to ? state.filterSpecs['date_range'].push(queries.date_to) : state.filterSpecs['date_range'].push('')

                queries.date_from ? state.filterSpecs['compare_date_range'].push(queries.compare_date_from) : state.filterSpecs['compare_date_range'].push('')
                queries.date_to ? state.filterSpecs['compare_date_range'].push(queries.compare_date_to) : state.filterSpecs['compare_date_range'].push('')

                if(queries.shop) {
                    if(Array.isArray(queries.shop)) {
                        state.filterSpecs['shop'] = queries.shop
                    } else {
                        state.filterSpecs['shop'] = [queries.shop]
                    }
                }
            }
            state.filterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data
        }
    },

    actions: {
        async getReportFilterset({ commit, state }) {
            try {
                const response = await apiClient.get("/reports/nps/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                console.log(response.data);
                state.filtersetLoading = true
                commit('setFilterset', response.data)
            } catch(err) { // Если есть ошибка
                console.log(err);
            }
        },

        getMainData({ commit, state, dispatch }) {
            state.feedbackLoading = true

            if(router.currentRoute.value.fullPath.split('?')[1]) {
                apiClient.get("/reports/nps/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    console.log(response.data);
                    commit('setFeedbackData', response.data.data)
                    commit('setExcelData', response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                });
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post("/reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })
                const now = new Date()
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
                
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}
